import React, { useEffect, useState } from 'react';
import { PromptForm } from './PromptForm';
import { PromptResult } from './PromptResult';
import { ChevronDownIcon, Sparkles, Lightbulb, Wand2Icon } from 'lucide-react';
export function PromptGenerator({
  sendToGrok
}) {
  const [formData, setFormData] = useState({
    promptType: '',
    gradeLevel: '',
    subject: '',
    customSubject: '',
    topic: '',
    learningObjectives: '',
    priorKnowledge: '',
    themeContext: '',
    additionalContext: '',
    timeConstraint: '',
    outputFormat: '',
    aiRole: '',
    negativePrompts: [],
    customNegativePrompt: '',
    outputLanguages: ['English'] // Default to English
  });
  const [generatedPrompt, setGeneratedPrompt] = useState('');
  return <div className="min-h-screen bg-gradient-to-b from-blue-50 to-indigo-50" data-id="element-239">
      <div className="max-w-6xl mx-auto px-4 py-6 sm:py-8" data-id="element-240">
        <header className="text-center mb-8 sm:mb-12 bg-white rounded-2xl shadow-sm p-4 sm:p-8 border border-indigo-100" data-id="element-241">
          <div className="flex justify-center mb-4 sm:mb-6" data-id="element-242">
            <div className="bg-indigo-600 p-3 rounded-full text-white" data-id="element-243">
              <Wand2Icon size={24} className="sm:w-7 sm:h-7" data-id="element-244" />
            </div>
          </div>
          <h1 className="text-2xl sm:text-3xl font-bold text-indigo-900 mb-2 sm:mb-3" data-id="element-245">
            Welcome to Your Teaching Prompt Assistant!
          </h1>
          <p className="text-base sm:text-lg text-gray-600 mb-4 max-w-2xl mx-auto" data-id="element-246">
            Create perfect AI prompts for lesson planning, assessments, and
            more. Let's make teaching easier together!
          </p>
          <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mt-4 sm:mt-6" data-id="element-247">
            <div className="flex items-center bg-indigo-50 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full" data-id="element-248">
              <Sparkles size={16} className="text-indigo-600 mr-1.5 sm:mr-2 sm:w-[18px] sm:h-[18px]" data-id="element-249" />
              <span className="text-sm sm:text-base text-indigo-700 font-medium" data-id="element-250">
                Save hours of planning time
              </span>
            </div>
            <div className="flex items-center bg-indigo-50 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full" data-id="element-251">
              <Lightbulb size={16} className="text-indigo-600 mr-1.5 sm:mr-2 sm:w-[18px] sm:h-[18px]" data-id="element-252" />
              <span className="text-sm sm:text-base text-indigo-700 font-medium" data-id="element-253">
                Tailored to your classroom
              </span>
            </div>
          </div>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-254">
          <PromptForm formData={formData} setFormData={setFormData} setGeneratedPrompt={setGeneratedPrompt} data-id="element-255" />
          <PromptResult generatedPrompt={generatedPrompt} formData={formData} sendToGrok={sendToGrok} data-id="element-256" />
        </div>
        <footer className="mt-10 sm:mt-16 text-center text-sm text-gray-500" data-id="element-257">
          <p data-id="element-258">
            Use these prompts with ChatGPT, Claude, or other AI assistants to
            enhance your teaching.
          </p>
          <p className="mt-3 text-indigo-600 font-medium flex flex-col items-center" data-id="element-259">
            Try Grok 4 now
            <span className="flex mt-1" data-id="element-260">
              <ChevronDownIcon size={16} data-id="element-261" />
              <ChevronDownIcon size={16} data-id="element-262" />
              <ChevronDownIcon size={16} data-id="element-263" />
            </span>
          </p>
        </footer>
      </div>
    </div>;
}